module.exports = __webpack_public_path__ + "img/clothing159.7a4ec5e5.jpg";